var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('li',[_c('a',{attrs:{"href":_vm.cartLink}},[_c('i',{staticClass:"fas fa-shopping-cart"},[_vm._v("("),_c('span',{attrs:{"id":"shoptext"},domProps:{"textContent":_vm._s(_vm.quantity)}}),_vm._v(")")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }